import { takeEvery, put } from 'redux-saga/effects'
import { API, STATUS } from '@vezeeta/web-utils'
import CoustomUrls from 'configs/urls'

import { PRODUCTS } from '../actions/product'
import { productsEnum } from '../../utils/product'

function* getProducts({ payload }) {
    const api = new API()
    const productTypeId = payload?.productTypeId || productsEnum.BookingType
    const res = yield api.get(`${CoustomUrls.getProducts}?productTypeId=${productTypeId}`, [
        {
            key: 'AuthenticationKey',
            value: process.env.REACT_APP_VOUCHERS_AUTHENTICATIONKEY
        }
    ], true)

    if (STATUS.isSuccess(res.status))
        yield put({
            type: PRODUCTS.LOAD_DONE,
            products: res.response
        })
    else
        yield put({
            type: PRODUCTS.LOAD_FAILED
        })
}

export default function* product() {
    yield takeEvery(PRODUCTS.LOAD, getProducts)
}